import React from "react";
import { useInvoiceActions } from "../../../hooks/useInvoiceActions";
import { useInvoice } from "../../../hooks/invoice/useInvoice";
import { usePaymentFlow } from "../../../hooks/usePaymentFlow";
import { ModalCharge } from "../../../shared/ModalCharge/ModalCharge";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { img } from "../../../../../../assets/img";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { Input } from "../../../../../../shared/Input/Input";
import { InputError } from "../../../../../../shared/InputError/InputError";
import { InputPhone } from "../../../../../../shared/InputPhone/InputPhone";
import classes from "../scss/ViewChargeSunbit.module.scss";

const PaymentFormModal = ({ isTipsApplying, form, isLoading }) => {
  const { paymentViewClose } = useInvoiceActions();
  const { invoice } = useInvoice();
  const { isTipsAvailable } = usePaymentFlow();
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();

  const { values, setFieldValue, errors, handleSubmit, handleBlur, touched } =
    form;

  return (
    <ModalCharge
      isOpen
      onClose={paymentViewClose}
      title={tSales("checkoutInvoice.paymentOptions.sunbit")}
      imageSrc={img.sunbit}
      imageClassName={classes.titleIcon}
      onCharge={handleSubmit}
      isCharging={isLoading}
      isChargeDisabled={isTipsApplying}
      chargeLabel={
        isTipsAvailable ? tCommon("label.continue") : tCommon("label.apply")
      }
    >
      <ModalCharge.InputWrap>
        <InputLabel>{tSales("checkoutInvoice.formInputLabel.mail")}</InputLabel>
        <Input
          type="email"
          size="small"
          name="email"
          value={values.email}
          isError={Boolean(errors.email) && Boolean(touched.email)}
          onChange={(e) => setFieldValue("email", e.target.value)}
          onBlur={handleBlur}
          placeholder={tCommon("formPlaceholder.email")}
          isDisabled={Boolean(invoice?.patient?.email)}
        />
        {Boolean(errors.email) && Boolean(touched.email) && (
          <InputError>{errors.email}</InputError>
        )}
      </ModalCharge.InputWrap>
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.phoneNumber")}
        </InputLabel>
        <InputPhone
          withSearch
          fullWidth
          variant="legacy-outlined"
          value={values.phoneNumber}
          onChange={(value, country, e, formattedPhone) => {
            setFieldValue("phoneNumber", formattedPhone);
          }}
          onBlur={handleBlur}
          inputProps={{ name: "phoneNumber" }}
          isError={Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber)}
        />
        {Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber) && (
          <InputError>{errors.phoneNumber}</InputError>
        )}
      </ModalCharge.InputWrap>
    </ModalCharge>
  );
};

export default PaymentFormModal;
